import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ReviewWorkflowsList from './List';
import ReviewWorkflowNew from './New';

export default function ReviewWorkflows() {
  return (
    <Routes>
      <Route
        index
        element={<ReviewWorkflowsList />}
      />
      <Route
        path=':id'
        element={<ReviewWorkflowNew />}
      />
      <Route
        path='*'
        element={
          <Navigate
            to='/admin/performance-reporting/review-workflows'
            replace
          />
        }
      />
    </Routes>
  );
}
